export type PageLifecycleTarget = {
  readonly addEventListener: (type: string, listener: EventListener) => void;
  readonly removeEventListener: (type: string, listener: EventListener) => void;
};

export function bindPageLifecycle(target: PageLifecycleTarget, dispose: () => void): () => void {
  let phase: "active" | "cached" | "terminated" = "active";
  const detach = (): void => {
    target.removeEventListener("pagehide", onPageHide);
    target.removeEventListener("pageshow", onPageShow);
  };
  const terminate = (): void => {
    if (phase === "terminated") return;
    phase = "terminated";
    detach();
    dispose();
  };
  const onPageHide: EventListener = (event) => {
    if (phase === "terminated") return;
    if (isPersistedTransition(event)) {
      phase = "cached";
      return;
    }
    terminate();
  };
  const onPageShow: EventListener = (event) => {
    if (phase === "cached" && isPersistedTransition(event)) phase = "active";
  };
  target.addEventListener("pagehide", onPageHide);
  target.addEventListener("pageshow", onPageShow);
  return terminate;
}

function isPersistedTransition(event: Event): boolean {
  return "persisted" in event && event.persisted === true;
}
